import { Pipe, PipeTransform } from '@angular/core';
import { getTooltipTextId } from '../utils/property-helpers';
import type { PropertyType } from '../../core/models/property-type.model';

@Pipe({
  name: 'tooltipTextId',
  standalone: false
})
export class TooltipTextIdPipe implements PipeTransform {
  transform(value: PropertyType, ...args: unknown[]): string {
    return value ? getTooltipTextId(value) : null;
  }
}
